import {
  Buildings,
  Users,
  Lightning,
  Warehouse,
  Wrench,
  Broadcast,
} from "@phosphor-icons/react";
import { subdomainImage } from "./utils";

const slug = "realty";

/** Realty — realty.bizlem.com */
const realtyConfig = {
  slug,
  name: "Realty",
  shortName: "Realty",
  host: "realty.bizlem.com",
  icon: Buildings,
  theme: {
    primary: "bg-teal-600",
    primaryHover: "hover:bg-teal-700",
    primaryText: "text-teal-600",
    primaryBorder: "border-teal-600",
    tint: "bg-teal-50",
    heroGradient: "from-teal-800 via-teal-600 to-teal-500",
    cream: "bg-teal-50/40",
    badge: "bg-teal-50 border-teal-200 text-teal-700",
    ring: "ring-teal-100",
  },
  hero: {
    badge: "AI-Powered Facility Intelligence",
    headline: ["Buildings that Think.", "Facilities that Respond."],
    highlightLine: 0,
    description:
      "Smart building operations, tenant intelligence, and energy optimization across commercial, residential, and mixed-use portfolios.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    ctaPrimary: "Request Demo",
    ctaSecondary: "Explore Solutions",
  },
  about: {
    label: "WHAT WE DO",
    heading: "Enabling property portfolios with smart, connected ecosystems",
    body: "From commercial towers to residential communities, our platform connects access, energy, tenant services, and maintenance into one intelligent facility management system.",
  },
  modules: {
    label: "MODULES",
    heading: "Integrated Modules. One Intelligent Portfolio.",
    body: "Every module works in sync — so access, energy, tenant experience, and maintenance all run on a single connected platform.",
    items: [
      { icon: Buildings, title: "Smart Buildings", body: "IoT-enabled building automation with HVAC, lighting, and environmental controls.", iconBg: "bg-teal-100 text-teal-700" },
      { icon: Users, title: "Tenant Management", body: "Digital tenant onboarding, service requests, and satisfaction analytics.", iconBg: "bg-blue-100 text-blue-700" },
      { icon: Lightning, title: "Energy Optimization", body: "Real-time energy monitoring, demand response, and sustainability reporting.", iconBg: "bg-amber-100 text-amber-700" },
      { icon: Warehouse, title: "Parking & Access", body: "Smart parking allocation, visitor management, and biometric access control.", iconBg: "bg-violet-100 text-violet-700" },
      { icon: Wrench, title: "Facilities Operations", body: "Work order automation, preventive maintenance, and vendor management.", iconBg: "bg-orange-100 text-orange-700" },
      { icon: Broadcast, title: "Portfolio Command Center", body: "Unified dashboard for multi-property portfolio performance and alerts.", iconBg: "bg-emerald-100 text-emerald-700" },
    ],
  },
  solutions: {
    label: "SOLUTIONS",
    heading: "Built for every property type",
    items: [
      {
        title: "Commercial Offices",
        points: ["Space utilization analytics", "Meeting room automation", "Employee experience apps", "Energy benchmarking"],
        image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Residential Communities",
        points: ["Resident access automation", "Amenity booking systems", "Community security", "Maintenance request portals"],
        image: subdomainImage(slug, "residential-communities.png"),
      },
      {
        title: "Retail & Mixed-Use",
        points: ["Footfall analytics", "Tenant mix optimization", "Common area management", "Revenue per square foot tracking"],
        image: "https://images.unsplash.com/photo-1449844908441-8829872d2607?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Industrial Parks",
        points: ["Multi-tenant facility management", "Utility monitoring", "Safety & compliance", "Logistics coordination"],
        image: subdomainImage(slug, "industrial-parks.png"),
      },
    ],
  },
  whyChoose: {
    label: "WHY CHOOSE US",
    heading: "Built for Scale. Designed for Simplicity.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    items: [
      "One unified platform for all facility operations",
      "Scalable from single buildings to global portfolios",
      "Proven energy savings and tenant satisfaction gains",
      "Seamless integration with existing BMS and ERP systems",
    ],
  },
  footerTagline:
    "AI-Powered Facility Intelligence — connecting buildings, tenants, and operations into one intelligent ecosystem.",
  contactIndustry: "Realty & Facilities",
};

export default realtyConfig;
